export function isEvaluationPublished(status?: string | null): boolean {
  return status === 'Completed' || status === 'CompletedButNoGrade';
}
